import React, { Fragment, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import OtpInput from 'react-otp-input'
import { Button } from 'loyal-react'

import '@loyal_template/password.css'

const PasswordBox = ({
  password,
  isLoading,
  onValidatePassword,
  onChangePassword,
  isValid
}) => {
  const changePassword = e => {
    onChangePassword(e)
  }

  const passwordContainerRef = useRef()

  useEffect(() => {
    const inputs = passwordContainerRef.current.querySelectorAll('input')
    inputs.forEach((input, index) => {
      input.setAttribute('aria-label', `${index + 1}º digito`)
    })
  }, [])

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 border-color-ui-3 bg-white border radius'>
          <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
            <section className='col mr-auto'>
              <h1 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                informe sua nova senha da central de atendimento
              </h1>
            </section>
          </div>
          <div className='col-12 border-color-ui-3'>
            <p className='my-2'>
              crie uma nova senha numérica para falar com a central de atendimento.
            </p>
            <p className='my-2'>
              cadastre uma senha de 6 números para utilizar nos atendimentos telefônicos.
              <br />
              A senha não pode conter informações pessoais e nem ser sequencial.
            </p>
            <div
              ref={passwordContainerRef}
              className='col-12 password-numeric-box pos-relative t-1'
              aria-label='Campos de senha numérica'
            >
              <OtpInput
                name='password'
                id='password'
                value={password}
                onChange={changePassword}
                shouldAutoFocus
                numInputs={6}
                tabIndex='0'
                focusStyle={{ outline: 0 }}
              />
            </div>
            <div className='col-12 col-md-6 mt-2'>
              <div className='col-12 px-0 pb-2'>
                <Button
                  id={'btn-password'}
                  name={'btn-password'}
                  className='btn btn-sm btn-featured border border-color-ui-3 mr-1'
                  type='button'
                  text='confirmar e continuar'
                  disabled={!isValid}
                  onClick={onValidatePassword}
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

PasswordBox.propTypes = {
  password: PropTypes.string.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onValidatePassword: PropTypes.func,
  isValid: PropTypes.bool,
  isLoading: PropTypes.bool
}

export default PasswordBox



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/ChangeUraPassword/PasswordBox/PasswordBox.js